export type InspectionStatus = '' | 'OK' | 'Minor' | 'Critical'

export interface InspectionItem {
    label: string
    status: InspectionStatus
}

function item(label: string): InspectionItem {
    return { label, status: '' }
}

export class DailyReport {
    id?: string
    dateTime: Date | null = new Date()
    jobName = ''
    jobNumber = ''
    operatorName: number = 0
    equipmentId = ''

    preStartWalkAround: InspectionItem[] = [
        item('Visible damage or leaks'),
        item('Low / leaking fluids'),
        item('Tires / tracks damaged or worn'),
        item('Loose or missing parts'),
        item('Hoses / fittings damaged or leaking'),
        item('Battery loose or corroded'),
        item('Steps, handrails, guards damaged'),
    ]

    safetyEquipment: InspectionItem[] = [
        item('Fire extinguisher missing / not charged'),
        item('Seatbelt not working'),
        item('Horn not working'),
        item('Backup alarm not working'),
        item('Lights / beacons not working'),
        item('Mirrors / camera damaged or not visible'),
    ]

    engineOperation: InspectionItem[] = [
        item('Engine hard to start / not starting'),
        item('Unusual noises or vibration'),
        item('Gauges not working properly'),
        item('Warning lights on'),
        item('Steering / controls not responsive'),
        item('Brakes not working properly'),
    ]

    hydraulicsAttachments: InspectionItem[] = [
        item('Hydraulics not operating smoothly'),
        item('Hydraulic leaks'),
        item('Attachment loose or damaged'),
        item('Pins / locks missing or not secure'),
    ]

    workAreaFinalCheck: InspectionItem[] = [
        item('Unsafe work area conditions'),
        item('Hazardous ground conditions'),
        item('Overhead / underground hazards present'),
        item('Equipment excessively dirty / unsafe'),
    ]

    issueDetails = ''
    equipmentStatus = ''
}
